import { SalesforceField } from 'model/SalesforceField';
import Checkbox from 'components/Generic/Forms/FormFields/FormCheckbox';
import React, { useMemo } from 'react';
import { useFormContext } from 'components/Generic/Forms/SalesforceIntegratedForms/FormContext';
import styles from '../../../styles/Forms/SalesforceCheckbox.module.scss';

const SalesforceCheckBox = ({ fields, stepName, formData }: SalesforceField) => {
  const { updateFormData, updateSummary } = useFormContext();
  const handleChange = (value: boolean): void => {
    updateFormData({ fieldName: fields.salesforceFieldId.value, value });
    updateSummary({
      fieldValue: value,
      fieldName: {
        storeName: fields.salesforceFieldId.value,
        displayName: fields.title.value,
      },
      stepName: stepName,
    });
  };

  const isSelected = useMemo(() => {
    for (const [key, value] of Object.entries(formData.records[0])) {
      if (key === fields.salesforceFieldId.value) {
        return value;
      }
    }
  }, [formData, fields.salesforceFieldId.value]);

  return (
    <div className={styles['salesforce-checkbox']}>
      <Checkbox
        dataId={fields.salesforceFieldId.value}
        required={fields.isRequired.value}
        selected={isSelected}
        onChange={handleChange}
        slots={{
          label: <p className="body-small">{fields.title.value}</p>,
          error: <p className="body-small">This field is required</p>,
        }}
      />
    </div>
  );
};

export default SalesforceCheckBox;
